import { copy } from 'cerebral/operators'

export default [copy('input:value', 'state:login.acceptedGDPR')]



// WEBPACK FOOTER //
// ./src/modules/login/chains/setAcceptGDPR.js